<template>
	<Modal
    :value="visible"
    @on-cancel="cancelHandler"
    footer-hide
    :title="curRule && curRule.index >= 0 ? '编辑规则' : '增加规则'"
		width="600">
		<div class="container">
			<Form :model="formData" ref="form" :label-width="100">
				<FormItem label="规则" prop="conditions">
          <div>
					  <condition-item
              style="margin-bottom: 10px"
              v-for="(item, index) in formData.conditions"
              :key="index"
              :value="item"
              @input="formData.conditions.splice(index, 1, $event)"
              @delete="formData.conditions.splice(index, 1)"
            />
            <Row>
              <Col span="22" offset="1">
                <Button type="dashed" long @click="addCondition" icon="md-add">添加规则</Button>
              </Col>
            </Row>
          </div>
				</FormItem>
        <FormItem label="动作" prop="action">
          <Row :gutter="16">
            <Col span="12">
              <Select v-model="formData.action">
                <Option value="rate">设置评级</Option>
                <Option value="sms">发送短信</Option>
						    <Option value="api">接口调用</Option>
              </Select>
            </Col>
            <Col span="12">
              <form-item-rating
                v-model="formData.action_data"
                v-show="formData.action === 'rate'"
                :formItemProps="{
                  label: '',
                }"
              />
              <FormItemApiSetting v-if="formData.action === 'api'" v-model="formData.action_data" />
            </Col>
          </Row>
          <!-- <InputNumber :min="0" :max="7" v-model="formData.action_data" v-show="formData.action === 'rate'" /> -->
        </FormItem>
        <FormItem label="终止匹配">
          <RadioGroup v-model="formData.end">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <form-item-tag v-model="formData.tag"/>
        <form-item-var
          v-model="formData.vars"
          :formItemProps="{ prop: 'vars' }"
        />
				<div class="flex flex-end">
					<Button style="margin-right: 20px" @click="cancelHandler">取消</Button>
					<Button type="primary" @click="submit">确定</Button>
				</div>
			</Form>
		</div>
	</Modal>
</template>
<script>
import { mapState } from 'vuex';
import FormItemTag from '../../../components/FormItemTag.vue';
import FormItemVar from '../../../components/FormItemVar.vue';
import conditionItem from './ConditionItem.vue';
import cloneDeep from 'lodash/cloneDeep'
import FormItemRating from '../../../components/FormItemRating.vue';
import FormItemApiSetting from '../../../components/FormItemApiSetting.vue';

export default {
  components: { conditionItem, FormItemTag, FormItemVar, FormItemRating, FormItemApiSetting },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    curRule: {
      type: Object,
    }
  },
	data() {
		return {
			formData: {
				conditions: [],
        action: '',
        action_data: '',
        end: '0',
        tag: '',
        vars: [],
      },
		}
	},
	computed: {
    ...mapState('setting', [
			'vars',
    ]),
	},
	watch: {
		curRule(val) {
			if (!val) return
      this.formData = {
        ...cloneDeep(val),
        vars: cloneDeep(val.vars || []),
        end: val.end ? '1' : '0'
      }
		}
	},
	methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const formData = this.formData;
				this.$emit('onSubmit', {
          ...formData,
          action_data: (formData.action === 'rate' || this.formData.action === 'api') ? `${formData.action_data}` : '',
          end: formData.end === '1'
        });
        this.cancelHandler();
      })
    },
		cancelHandler() {
      this.$refs.form.resetFields()
      this.formData = {
				conditions: [],
        action: '',
        action_data: '',
        end: '0',
        tag: '',
        vars: [],
      }
      this.$emit('change', false)
      this.$emit('onCancel')
		},

    // 添加规则
    addCondition() {
      this.formData.conditions.push({ rule: '', op: '', value: '' })
    },
    

  }
}
</script>
<style lang="scss" scoped>
</style>